import React from "react";
// import ConfirmDialog from "../confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";

import { useToast } from "@/src/lib/hooks/useToast";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useRouter } from "next/router";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomButton from "@/src/lib/ui/Button";

const AddressMismatchPopup = ({ open, onClose, cartDetails }) => {
    const { showToast } = useToast();
    const router = useRouter();

    const mismatchMessage = open?.message
        ? open.message
        : "Your item is currently in a cart from a different address. Please switch to the correct address.";

    const handleMutationSuccess = (data) => {
        onClose();
        showToast(data, "success");
        router.push("/cart");
    };

    const handleMutationError = (error) => {
        console.error("Error switching cart address:", error);
        showToast(error, "error");
    };

    const switchToOldCartMutation = useHODMutation(
        cartApiService.switchToOldCartAddress,
        {
            onSuccess: handleMutationSuccess,
            onError: handleMutationError,
        }
    );

    const switchToNewCartMutation = useHODMutation(
        cartApiService.switchToNewCartAddress,
        {
            onSuccess: handleMutationSuccess,
            onError: handleMutationError,
        }
    );

    const handleSwitch = (type) => {
        const payload =
            type === "old"
                ? {
                      oldPincode: open?.errorData?.oldPincode,
                      oldAddressGuid: open?.errorData?.oldAddressGuid,
                      itemCartObject: cartDetails,
                  }
                : {
                      addressGuid: open?.errorData?.newAddressGuid,
                      itemCartObject: cartDetails,
                  };

        if (type === "old") {
            switchToOldCartMutation.mutate(payload);
        } else {
            switchToNewCartMutation.mutate(payload);
        }
    };

    return (
        <ConfirmDialog
            open={!!open}
            onClose={onClose}
            maxWidth="md"
            title={
                <div className="flex flex-row items-center gap-2">
                    <Iconify icon={IconCode.error} width={30} color="#B71D18" />
                    <h6 className="text-black">Address Mismatch</h6>
                </div>
            }
            content={
                <>
                    <p className="text-gray-700 text-sm">{mismatchMessage}</p>

                    <div container className="flex justify-end mt-2">
                        <div className="flex flex-row gap-2">
                            <CustomButton
                                variant="outlined"
                                onClick={() => handleSwitch("old")}
                                disabled={switchToOldCartMutation.isPending}
                                className="capitalize font-bold px-4 mr-1 rounded-md"
                            >
                                Switch to Old Address
                            </CustomButton>

                            <CustomButton
                                variant="contained"
                                onClick={() => handleSwitch("new")}
                                disabled={switchToNewCartMutation.isPending}
                                className="capitalize font-bold px-2 rounded-md bg-primary hover:bg-primary/80"
                            >
                                Switch to New Address
                            </CustomButton>
                        </div>
                    </div>
                </>
            }
            isCancel
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                    },
                },
            }}
        />
    );
};

export default AddressMismatchPopup;
